import http from "../httpService";
import { apiUrl } from "../../../config.js";
const apiEndpoint = apiUrl + "/sales/quotation/";

export function getQuotations() {
  return http.get(apiEndpoint + "data");
}

export function getQuotation(quotationID = 0, passAuth = "false") {
  return http.get(
    apiEndpoint + "quotation-detail/" + quotationID + "/" + passAuth
  );
}

export function getQuotationItems(quotationID) {
  return http.get(apiEndpoint + "quotation-items/" + quotationID);
}

export function saveQuotation(quotation) {
  return http.post(apiEndpoint, quotation);
}

export function cancelQuotation(quotationID = 0) {
  return http.delete(apiEndpoint + "quotation/" + quotationID);
}

export function convertToSalesOrder(quotation) {
  return http.post(apiEndpoint + "convert-to-so", quotation);
}
